import React, { useState } from "react";
import { postRemindGetUserRemindSystemCount as getRemindCount } from "@zkt/open-api/esm/user-api";
import {
  BellFill,
  QuestionCircleFill,
  MessageFill,
  Room,
  ArrowLeftRight,
} from "@zkt/icons";
import {
  config,
  useI18n,
  I18nContext,
  usePromiseWithContext,
  useCallbackWithContext,
  useUser,
} from "@zkt/eb-utility";
import { Button, Badge, Layout } from "@zkt/components";
import { Link } from "react-router-dom";
import { postEbConfigSetHotelConfig } from "@zkt/open-api/esm/merchant";
import { goToEbooking } from "@/utilities/route";
import UserInfo from "./user-info";
import HotelInfo from "./hotel-info";
import "./index.scss";
import { texts } from "./i18n";
import AIAnswer from "./ai-answer";

export default function Topbar(): JSX.Element {
  // const [language, setLanguage] = useLanguage();

  const i18n = useI18n(texts);

  const { user } = useUser();
  const showSwitchOldVersion = !user?.channelCode;

  // 左上角消息提醒数量
  const { result: count } = usePromiseWithContext(({ merchantId, userId }) => {
    return getRemindCount({ hotelId: merchantId, userId }).then(
      (res) => res.notReadCount
    );
  }, []);

  const handleVersionSwitch = useCallbackWithContext((auth) => {
    const { merchantId, userId } = auth;
    postEbConfigSetHotelConfig(
      { hotelId: merchantId, userId: String(userId) },
      {
        key: "ENABLE_UI_UPGRADE_ALL",
        value: "0",
        userId: String(userId),
      }
    ).then(() => goToEbooking(auth.token));
  }, []);

  return (
    <I18nContext.Provider value={i18n}>
      <Layout.Header className="main-index-topbar">
        <HotelInfo />
        <nav className="flex-auto pl-3" />
        {/* <Switch
          defaultChecked={language === Language.ZH_CN}
          checkedChildren="中"
          unCheckedChildren="EN"
          onChange={(c) => setLanguage(c ? Language.ZH_CN : Language.EN_US)}
        /> */}
        {/* <Switch
          className="ms-3"
          defaultChecked={theme === Theme.DARK}
          checkedChildren="Dark"
          unCheckedChildren="Light"
          onChange={(c) => setTheme(c ? Theme.DARK : Theme.LIGHT)}
        /> */}
        {showSwitchOldVersion ? (
          <div className="btn-link">
            <ArrowLeftRight width="21" height="21" fill="#bfbfbf" />
            <Button type="link" onClick={handleVersionSwitch}>
              {i18n.switchOldVersion}
            </Button>
          </div>
        ) : null}
        <AIAnswer />
        <div className="btn-link">
          <QuestionCircleFill width="20" height="20" fill="url(#g-topbar)">
            <defs>
              <linearGradient gradientTransform="rotate(45)" id="g-topbar">
                <stop offset="0" stopColor="#61a9f8" />
                <stop offset="1" stopColor="#4d6bf6" />
              </linearGradient>
            </defs>
          </QuestionCircleFill>
          <Link rel="noopener" to={`//${config.helpHOST}`} target="_blank">
            {i18n.helperCenter}
          </Link>
        </div>
        <div className="btn-link">
          <MessageFill width="24" height="22" fill="url(#g-topbar)" />
          <Link to="/#/question-feed-back/question-feed-back">
            {i18n.feedbacks}
          </Link>
        </div>
        <div className="btn-link">
          <Badge size="small" count={count}>
            <BellFill width="20" height="22" fill="url(#g-topbar)" />
          </Badge>
          <Link to="/#/notice/system/list">{i18n.systemMessages}</Link>
        </div>
        <UserInfo />
      </Layout.Header>
    </I18nContext.Provider>
  );
}
